export default "__VITE_ASSET__2d129e51__"